const USUARIOS_DO_GATEWAY = ["27"];

export function podeVerGateway(user) {
  return USUARIOS_DO_GATEWAY.includes(String(user?.user_id ?? ""));
}
